export default __webpack_public_path__ + "bonus-chest.gif";